/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de pago comisiones.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmPagoComisiones from "../../administracion/FrmPagoComisiones.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmPagoComisionesPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmPagoComisiones">
      <FrmPagoComisiones />
    </SizeSoftXFrmPortatil>
  );
}
